import { render, staticRenderFns } from "./DashParentGeneralites.vue?vue&type=template&id=f9868ac4&"
import script from "./DashParentGeneralites.vue?vue&type=script&lang=js&"
export * from "./DashParentGeneralites.vue?vue&type=script&lang=js&"
import style0 from "./DashParentGeneralites.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports